import { Fragment } from 'react'

/* blocks */
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'

interface Props {
  primaryCta?: { title: string; url: string }
}

function Header({
  primaryCta = {
    title: 'Register Now',
    url: '#details'
  }
}: Props) {
  return (
    <Fragment>
      <MobileHeader className="lg:hidden" primaryCta={primaryCta} />
      <DesktopHeader className="hidden lg:block" primaryCta={primaryCta} />
    </Fragment>
  )
}

export default Header
